import { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

type CustomWeightProps = {
  semiLight?: boolean
  medium?: boolean
}

const semiLightCss = ({ semiLight }: CustomWeightProps) =>
  semiLight &&
  css`
    font-weight: ${themeGet('fontWeights.0')};
  `

const mediumCss = ({ medium }: CustomWeightProps) =>
  medium &&
  css`
    font-weight: ${themeGet('fontWeights.1')};
  `

export type { CustomWeightProps }
export { mediumCss, semiLightCss }
